import { render, staticRenderFns } from "./Form01.vue?vue&type=template&id=d13cdc72&scoped=true"
import script from "./Form01.vue?vue&type=script&lang=js"
export * from "./Form01.vue?vue&type=script&lang=js"
import style0 from "./Form01.vue?vue&type=style&index=0&id=d13cdc72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13cdc72",
  null
  
)

export default component.exports